import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-200 w-full py-4 mt-auto text-center">
      <p className="text-lg font-medium">
        &copy; {new Date().getFullYear()} JP. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
